import cx from 'classnames'

import type { SummaryCardProps } from '../types'

export function SummaryCard({ label, value, highlight, color }: SummaryCardProps): React.ReactNode {
  return (
    <div
      className={cx(
        'px-4 py-2 rounded-lg border bg-white min-w-[100px]',
        highlight && 'border-lucent-primary bg-blue-50'
      )}
    >
      <div className='text-[10px] uppercase text-gray-500 font-medium'>{label}</div>
      <div
        className={cx(
          'text-lg font-semibold',
          color === 'green' && 'text-green-600',
          color === 'orange' && 'text-orange-500',
          color === 'red' && 'text-red-600',
          !color && 'text-gray-800'
        )}
      >
        {value}
      </div>
    </div>
  )
}
